import { Component, HostBinding, Input } from '@angular/core';
import { iLeaveApprovalHierarchy } from 'src/app/helpers/Interfaces/leaves';

@Component({
  selector: 'approval-status-popover',
  templateUrl: './status-popover.component.html',
  styleUrls: ['./status-popover.component.scss'],
})
export class StatusPopoverComponent {
  @HostBinding('class.leave-status-popover') hasClass = true;
  @Input()
  statusList: iLeaveApprovalHierarchy[] = [];
  @Input()
  currentLevel: iLeaveApprovalHierarchy | undefined = {
    employeeId: '',
    name: '',
    comment: '',
    status: 0,
    alternateEmployeeId: null,
    alternateEmployee: null,
  };
  statuses: { status: number; label: string; color: string }[] = [
    {
      status: 0,
      label: 'Pending',
      color: '#ffe715',
    },
    { status: 1, label: 'Approved', color: '#4caf50' },
    { status: 2, label: 'Rejected', color: '#f22112' },
  ];
}
